<script setup>
import { token_expired } from '@/assets/js/token_expired';
import axios from "axios";
import Swal from "sweetalert2";
import { ref, onMounted, onBeforeUnmount,defineEmits } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const router = useRouter();
const store = useStore();

const load = ref(false);
const user_operate = ref(false);

const header = ref(null);

const school = ref(null);
const name = ref(null);

const unit = ref("");
const level_branch = ref(null);

const emits = defineEmits([
  "sbu_audio_open",
]);

function goTo(data) {
  emits("sbu_audio_open", false);
  console.log("關閉音檔");
  
  router.push(`${data}`);
}

function toggleDropdown() {
  
  user_operate.value = !user_operate.value;
}

function closeDropdown(event) {
  // 檢查點擊是否發生在下拉菜單之外
  if (user_operate.value && !event.target.closest(".header_info")) {
    user_operate.value = false;
  }
}

function get_info() {
  emits("sbu_audio_open", false);

  const FormData = require("form-data");
  let data = new FormData();

  data.append("tch_account", localStorage.getItem("ac"));

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/teacher-info/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      if(response.status == 520){
        get_info();
      }
      console.log("HEADER",response);
      token_expired(response, router);
      school.value = response.data.data.school_name;
      name.value = response.data.data.tch_name;
      localStorage.setItem("school_guid",response.data.data.school_guid)
      load.value = true;
    })
    .catch((error) => {

      if (error.response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (error.response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if(error.status == 520){
        get_info();
      }
      token_expired(error, router);
      console.log(error.response.data.code);
    });
}

function sign_out() {
  // emits("sbu_audio_open", false);

  if (localStorage.getItem("remember") == 'true') {
    localStorage.removeItem('choose');
    localStorage.removeItem('level');
    localStorage.removeItem('level_branch');
    localStorage.removeItem('school_guid');
    localStorage.removeItem('token');
    localStorage.removeItem('unit');

    router.push("/");
  }else{
    localStorage.clear();
    router.push("/");
  }

}

// function adjustScale(element) {
//   // 獲取當前的縮放比例
//   const currentZoom = window.devicePixelRatio || 1;

//   // 反向縮放，使之看起來像 100%
//   const inverseZoom = 1 / currentZoom;

//   // 使用 CSS transform 來反向縮放
//   element.style.zoom = inverseZoom;
  
// }

onMounted(() => {
  get_info();
  document.addEventListener("click", closeDropdown);

  level_branch.value = localStorage.getItem("level_branch");
  unit.value = localStorage.getItem("unit");

  // adjustScale(header.value);
  // school.value = JSON.parse(localStorage.getItem("user_info")).School
  // name.value = JSON.parse(localStorage.getItem("user_info")).Name
});

onBeforeUnmount(() => {
  document.removeEventListener("click", closeDropdown);
});
</script>

<template>
  <div id="header" ref="header">
    <div v-if="load" class="header_info" @click="goTo('/choose')">
      <img src="@/assets/images/header/book.svg" alt="icon" />
      <span>{{unit}}／{{ level_branch }}</span>
      <img src="@/assets/images/header/right_arrow.svg" alt="icon" />
    </div>
    <div v-if="load" class="header_info" @click="toggleDropdown">
      <img src="@/assets/images/header/avatar.svg" alt="icon" />
      <span>{{ school }}／{{ name }}</span>
      <img src="@/assets/images/header/down_arrow.svg" alt="icon" />

      <div @click.stop class="drop_down_win" :class="{ active: user_operate }">
        <img
          class="arrow"
          src="@/assets/images/header/down_arrow.svg"
          alt="icon"
        />
        <button @click="goTo('/basic_info')">
          <span class="btn_icon">
            <img src="@/assets/images/header/id-card.svg" alt="icon" />
          </span>
          <span>Basic Information</span>
        </button>
        <button @click="goTo('/change_pw')">
          <span class="btn_icon">
            <img src="@/assets/images/header/lock.svg" alt="icon"/>
          </span>
          <span>Change password</span>
        </button>
        <button @click="sign_out()" class="trn">
          <span class="btn_icon"><img src="@/assets/images/header/exit.svg" alt="icon"/></span>
          <span>Sign out</span>
        </button>
      </div>
    </div>
  </div>
</template>


